import React from 'react';
import canaLogo from '../assets/Cana.png';

/**
 * Enhanced Logo Component with SVG-based Modern Design
 * @param {Object} props
 * @param {string} [props.className]
 * @param {'sm'|'md'|'lg'|'xl'|'2xl'} [props.size]
 * @param {boolean} [props.showText]
 * @param {'full'|'icon'|'text'} [props.variant]
 */
export default function Logo({ 
  className = '', 
  size = 'md', 
  showText = true, 
  variant = 'full',
  theme = 'light' // 'light' or 'dark'
}) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20',
    '2xl': 'w-24 h-24'
  };

  const LogoIcon = () => (
    <div className={`${sizeClasses[size]} relative flex items-center justify-center group`}>
      <img
        src={canaLogo}
        alt="Cana 101 logo"
        className="w-full h-full rounded-full object-cover drop-shadow-lg transition-transform duration-300 group-hover:scale-105"
      />
    </div>
  );

  const LogoText = () => (
    <div className="flex flex-col justify-center">
      <span className="text-lg font-bold leading-tight text-slate-800">
        Cana 101
      </span>
      <span className="text-sm font-medium text-slate-600">
        System
      </span>
    </div>
  );

  if (variant === 'icon') {
    return (
      <div className={className}>
        <LogoIcon />
      </div>
    );
  }

  if (variant === 'text') {
    return (
      <div className={className}>
        <LogoText />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoIcon />
      {showText && <LogoText />}
    </div>
  );
}